import { render, staticRenderFns } from "./ViewAndEdit.vue?vue&type=template&id=27ef7dd6&scoped=true&"
import script from "./ViewAndEdit.vue?vue&type=script&lang=js&"
export * from "./ViewAndEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef7dd6",
  null
  
)

export default component.exports